// extracted by mini-css-extract-plugin
export default {"root":"BillingPageContent_root__U06uU"};